import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const WrittenAnswerQuestion = ({ question, handleAnswer, answerStatus }) => {
    const { t } = useTranslation();
    const [userInput, setUserInput] = useState('');
    const inputRef = useRef(null); // Vytvoření ref pro vstupní pole
    const [error, setError] = useState(''); 

    useEffect(() => {
      inputRef.current.focus();
    }, []);


    const handleSubmitAnswer = (e) => {
        setError(null);   
        let answerInput = document.getElementById('writtenAnswerInput'); // Získání hodnoty z inputu
    
        if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
            const answer = answerInput.value.trim();
    
            if (!answer) { // Kontrola, jestli je input prázdný
                setError(t('enter-answer'));
                return;
            }
    
            handleAnswer(answer); // Odeslání odpovědi
        }
    };
  

    return (
      <div className="flex flex-col items-center justify-center gap-4">
          <div className="answerInputs">

              <input id="writtenAnswerInput"
                    type="text" 
                    className="text-input"
                    value={userInput} 
                    onChange={(e) => setUserInput(e.target.value)} 
                    onKeyDown={(e) => handleSubmitAnswer(e)}
                    placeholder={t('enter-answer')} 
                    ref={inputRef}
                    autoFocus
                    autoComplete="off"
              />
              <button  onClick={handleSubmitAnswer} className={`${answerStatus ? (answerStatus === 'correct' ? 'btn-green' : 'btn-red') : 'btn-primary'}`}>
                  {t('send-answer')}
              </button>


          </div>


          {error && <h3 className="error">{error}</h3>}

          <ul className="text-center text-secondary">
            {(question.color2 || question.color3 || question.image2 || question.image3) && (
              <li>{t('more-answers-divide-by-space')}</li>
            )}
          </ul>


      </div>  
    );
};

export default WrittenAnswerQuestion;
